import { Suspense, lazy, useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "react-day-picker/style.css";
import Loading from "./components/Loading";

const WhoAreYou = lazy(() => import("./pages/commons/WHOAREYOU"));

const CheckoutSuccess = lazy(() => import("./components/Checkout/Success"));

// UTM & Referrer Tracking
const sourceParam = new URLSearchParams(window.location.search).get('source');
if (sourceParam) { localStorage.setItem('source', JSON.stringify(decodeURIComponent(sourceParam))); }
const gclidParam = new URLSearchParams(window.location.search).get('gclid');
if (gclidParam) { localStorage.setItem('gclid', JSON.stringify(decodeURIComponent(gclidParam))); }
const addictionTypeParam = new URLSearchParams(window.location.search).get('addiction_type');
if (addictionTypeParam) { localStorage.setItem('addiction_type', JSON.stringify(decodeURIComponent(addictionTypeParam))); }
const firstVisitedPageParam = new URLSearchParams(window.location.search).get('first_visited_page');
if (firstVisitedPageParam) { localStorage.setItem('first_visited_page', JSON.stringify(decodeURIComponent(firstVisitedPageParam))); }
const referrerPageParam = new URLSearchParams(window.location.search).get('referrer_page');
if (referrerPageParam) { localStorage.setItem('referrer_page', JSON.stringify(decodeURIComponent(referrerPageParam))); }
if (window !== window.parent) {
  window.parent.postMessage({ type: 'getHistory' }, 'https://oserlechangement.com');
  window.addEventListener('message', (event) => {
    if (event.origin !== 'https://oserlechangement.com') return;
    if (event.data.type === 'historyData') {
      const linksHistory = event.data.data
      localStorage.setItem('links_history', JSON.stringify(linksHistory));
    }
  });
}

// Numéros de téléphone personnalisés
const phoneLea = new URLSearchParams(window.location.search).get('phone_lea');
if (phoneLea) { localStorage.setItem('phone_lea', JSON.stringify(decodeURIComponent(phoneLea))); }
const phoneLarissa = new URLSearchParams(window.location.search).get('phone_larissa');
if (phoneLarissa) { localStorage.setItem('phone_larissa', JSON.stringify(decodeURIComponent(phoneLarissa))); }
const phoneRaphaelle = new URLSearchParams(window.location.search).get('phone_raphaelle');
if (phoneRaphaelle) { localStorage.setItem('phone_raphaelle', JSON.stringify(decodeURIComponent(phoneRaphaelle))); }
const phoneMarion = new URLSearchParams(window.location.search).get('phone_marion');
if (phoneMarion) { localStorage.setItem('phone_marion', JSON.stringify(decodeURIComponent(phoneMarion))); }

// Récupérer le Client ID de GA4
const getClientIdFromCookie = () => {
  const gaCookie = document.cookie.split(";").find((cookie) => cookie.trim().startsWith("_ga="));
  if (!gaCookie) return null;
  const gaValue = gaCookie.split("=")[1];
  const clientId = gaValue.replace(/^GA\d+\.\d+\./, "");
  return clientId;
};

export default function App() {
  
  // GTM Initialisation with Client ID
  useEffect(() => {
    const interval = setInterval(() => {
      const clientId = getClientIdFromCookie();
      clientId && localStorage.setItem("cid", JSON.stringify(clientId));
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'event': 'initialisation', 'client_id': clientId ?? undefined });
      window.dataLayer.push({ 
        'event': 'general',
        'source': sourceParam ?? undefined,
        'addiction': addictionTypeParam ?? undefined,
      });
      clearInterval(interval);
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return <Suspense fallback={<Loading />}>
      <BrowserRouter>
        <Routes>
          {/* NOT FOUNDED PAGE OR ROOT PAGE ! */}
          <Route exact path="/" element={<WhoAreYou />} />
          <Route exact path="/depression-burnout" element={<WhoAreYou />} />
          <Route path="*" element={<WhoAreYou />} />

          {/* Réservation */}
          <Route exact path="/checkout/success" element={<CheckoutSuccess />} />

        </Routes>
      </BrowserRouter>
  </Suspense>
}